import { apiClient } from "../lib/api";

export const complianceApi = {
  listSources: () => apiClient.get("/compliance/sources"),
  updateSource: (id, payload) => apiClient.patch(`/compliance/sources/${id}`, payload),
  listCorrectiveActions: () => apiClient.get("/compliance/corrective-actions"),
  updateCorrectiveAction: (id, payload) => apiClient.patch(`/compliance/corrective-actions/${id}`, payload),
  listEmployeesForExport: () => apiClient.get("/employees/compliance-lookup"),
  exportInspectionPackage: (employeeId, payrollMonth) => apiClient.get(`/compliance/inspection-export/${employeeId}/${payrollMonth}`, { responseType: "blob" }),
  emailReadiness: () => apiClient.get("/compliance/email-readiness"),
  generateFullExport: (payload) => apiClient.post("/compliance/labor-office-exports", payload),
  listFullExports: () => apiClient.get("/compliance/labor-office-exports"),
  downloadFullExport: (id) => apiClient.get(`/compliance/labor-office-exports/${id}/download`, { responseType: "blob" }),
  submitFullExport: (id) => apiClient.post(`/compliance/labor-office-exports/${id}/submit`),
  followUpFullExport: (id, notes, dueDate) => apiClient.post(`/compliance/labor-office-exports/${id}/follow-up`, { notes, due_date: dueDate || null }),
};
